import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useMemberStatus } from '@/hooks/useAppState';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface MemberLockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  featureName?: string;
  description?: string;
}

export default function MemberLockDialog({
  open,
  onOpenChange,
  featureName = '此功能',
  description,
}: MemberLockDialogProps) {
  const navigate = useNavigate();
  const { member } = useMemberStatus();
  const isExpired = !member.isMember && member.planType !== 'none';

  const handleSubscribe = () => {
    onOpenChange(false);
    navigate('/subscribe');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-2xl p-6">
        <DialogHeader>
          <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-3">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          <DialogTitle className="text-center text-lg">
            {isExpired ? '会员已到期' : `${featureName}为会员专属`}
          </DialogTitle>
          <DialogDescription className="text-center text-sm">
            {description ?? (isExpired
              ? '续费后即可恢复专属功能，继续你的训练计划'
              : '开通会员后即可解锁全部专属内容和功能')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 mt-4">
          <Button
            className="w-full btn-primary-gradient text-white font-bold h-11 rounded-xl"
            onClick={handleSubscribe}
          >
            去{isExpired ? '续费' : '开通'}会员
          </Button>
          <Button
            variant="ghost"
            className="w-full h-11 rounded-xl text-muted-foreground hover:text-foreground"
            onClick={() => onOpenChange(false)}
          >
            暂不
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
